const { makeAutoObservable } = require("mobx");

class DataUserLoyalty {
    constructor() {
        makeAutoObservable(this);
    }

    images = [];
    userName = "";
    userSurname = "";
    userPhone = "";
    userDate = "";
    userData = {};
    placeId = "";
    tableSide = "Зал";
    savedUser = {};
}

export default new DataUserLoyalty();
